import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function StatsBanner() {
  const ongoingCount = comics.filter(c => c.status === 'ongoing').length;
  const completedCount = comics.filter(c => c.status === 'completed').length;
  const totalViews = comics.reduce((sum, c) => sum + c.views, 0);
  const avgRating = (comics.reduce((sum, c) => sum + c.rating, 0) / comics.length).toFixed(1);

  return (
    <section className="py-10 md:py-14 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-2">{ongoingCount}</p>
            <p className="text-sm text-primary-100">连载作品</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-2">{completedCount}</p>
            <p className="text-sm text-primary-100">完结作品</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-2">{avgRating}</p>
            <p className="text-sm text-primary-100">平均评分</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-heading font-bold text-background-50 mb-2">{(totalViews / 100000000).toFixed(1)}亿</p>
            <p className="text-sm text-primary-100">累计阅读</p>
          </div>
        </div>
      </div>
    </section>
  );
}